import axios from 'axios';
import store from './store';
import { mondayOf, dueWeek, COMPANY_TEAM } from './scoreboard';

// Your scorecard numbers still to enter (MyNumbers.vue, on Employee Home and the header's Numbers quick add). Each
// metric's number is asked for its team's due week (usually the week just finished; scoreboard.ts dueWeek).
// $store.state.numbersToEnter is how many are missing, which shows the header button.

export function dueWeekFor(m: any): string {
    return dueWeek(m.ReportWeek);
}

export function hasValue(m: any, week: string): boolean {
    return m.Values[week] !== undefined && m.Values[week] !== null;
}

// The ones with no number yet for their due week
export function missingNumbers(metrics: any[]): any[] {
    return metrics.filter((m: any) => !hasValue(m, dueWeekFor(m)));
}

// The metrics you own, with their last few weeks' numbers (API scoreboard.ts GET /mine). Also updates the count.
export async function loadMyMetrics(): Promise<any[]> {
    const data = (await axios.get(`${store.state.apiUrl}/api/scoreboard/mine`, { params: { week: mondayOf(new Date()) } })).data;
    // Company 1 doesn't use the Company scorecard (as on the Scoreboard)
    const hideCompany = store.state.user.companyID == 1;
    const metrics = data.Metrics.filter((m: any) => !hideCompany || m.Team != COMPANY_TEAM);
    store.state.numbersToEnter = missingNumbers(metrics).length;
    return metrics;
}

// Just the count, for the header button (App.vue, and after numbers are entered on the Scoreboard)
export async function refreshNumbersToEnter() {
    if(!store.state.user.employeeID) {
        store.state.numbersToEnter = 0;
        return;
    }
    await loadMyMetrics().catch(e => {
        console.log(e);
    });
}
